var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePaper2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5C16.5967 2.5 17.169 2.73705 17.591 3.15901C18.0129 3.58097 18.25 4.15326 18.25 4.75V6.25H16.75V15.25C16.75 15.8467 16.5129 16.419 16.091 16.841C15.669 17.2629 15.0967 17.5 14.5 17.5H4C3.40326 17.5 2.83097 17.2629 2.40901 16.841C1.98705 16.419 1.75 15.8467 1.75 15.25V13.75H13.75V15.25C13.75 15.4337 13.8175 15.611 13.9395 15.7483C14.0616 15.8856 14.2298 15.9733 14.4122 15.9948L14.5 16C14.6837 16 14.861 15.9325 14.9983 15.8105C15.1356 15.6884 15.2233 15.5202 15.2448 15.3378L15.25 15.25V4H5.5C5.3163 4.00002 5.139 4.06747 5.00172 4.18954C4.86444 4.31161 4.77674 4.47981 4.75525 4.66225L4.75 4.75V12.25H3.25V4.75C3.25 4.15326 3.48705 3.58097 3.90901 3.15901C4.33097 2.73705 4.90326 2.5 5.5 2.5H16Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePaper2Line);
export default __webpack_public_path__ + "static/media/file-paper-2-line.2f6647dbc400a60821ae4a153b44f348.svg";
export { ForwardRef as ReactComponent };